// extracted by mini-css-extract-plugin
export default {"button":"QrButton_button__nBmGT","error":"QrButton_error__C2TVM"};